//import packages from node modules
import React,{useState,useEffect,useRef,useCallback} from 'react'
import PropTypes from 'prop-types'
import { useSelector,useDispatch } from 'react-redux'
import {withRouter} from 'react-router-dom'

//import shared components
import Heading from '../../typography/heading'
import SolidButton from '../../button/solidbutton'

//import shared utility functions
import {
  getCID,
  getCurrentStep,
  getDataFromURL
} from '../../../../utilities/function/urlparams'

import {
  getCycle,
  getPriceByBillingCycleID
} from '../../../../utilities/function/billingCycle'

import Slider from 'react-rangeslider'
import { updateConfig } from '../../../../app/action'

let CustomHostingSlider = (props) =>{
  const {config,productConfig,callback,sliderIndex,setConfigOptions} = props
  const [value,setValue] = useState(0)
  const sliderRef = useRef(null)
  const initFlag = useRef(false)
  useEffect(()=>{
    if(sliderRef.current){
      const {slider} = sliderRef.current
      const currentClassname = slider.className
      slider.className = currentClassname + " shades-primary-background-1-100"
      if(slider.children && slider.children.length){
        for (const item of slider.children) {
          if(item.className==="rangeslider__fill"){
            item.className = "rangeslider__fill primary-background-1-100"
          }
          if(item.className==="rangeslider__handle"){
            item.className = "rangeslider__handle primary-border-1-100"
          }
        }
      }
    }
  },[sliderRef])
  useEffect(()=>{
    if(!initFlag.current){
      if(config && config.options && config.options.length>0 && productConfig){
        const getSelectedValueByOptionID = optionid =>{
          let selectedIndex = 0
          config.options.forEach((item,index)=>{
            if(item.id===optionid){
              selectedIndex = index
            }
          })
          return selectedIndex
        }
        if(productConfig.config && productConfig.config.length){
          const currentConfigOption = productConfig.config.find(i=>i.config_id===config.id)
          if(currentConfigOption && currentConfigOption.config_id && currentConfigOption.option_id){
            const {config_id,option_id} = currentConfigOption
            callback(config_id,option_id,sliderIndex,setConfigOptions)
            const v = getSelectedValueByOptionID(option_id)
            setValue(v)
            initFlag.current = true
          }
        }else{
          const selectedOption = config.options.find((item,index)=>index===0)
          callback(config.id,selectedOption.id,sliderIndex,setConfigOptions)
          const v = getSelectedValueByOptionID(selectedOption.id)
          setValue(v)
          initFlag.current = true
        }
      }
    }

  },[config,sliderIndex,productConfig,callback,setConfigOptions])
  if(config && productConfig){
    const {billing_cycle_id} = productConfig
    const {options,name} = config
    const getMin = () =>{
      return 0
    }
    const getMax = () =>{
      if(options && options.length){
        return options.length-1
      }
      return 0
    }
    const getSelectedOption = (val) =>{
      return options.find((item,index)=>index===val)
    }
    const getOptionValue = () =>{
      const selected = getSelectedOption(value)
      if(selected && selected.name){
        return (selected.name)
      }
      return (<></>)
    }
    const getName = () =>{
      return (name)
    }
    const renderPrice = () => {
      const selected = getSelectedOption(value)
      if(selected && selected.price){
        const {price} = selected
        if(price){
          const billingCycle = getPriceByBillingCycleID(price,billing_cycle_id)
          if(billingCycle && billingCycle.name){
            const cycle = getCycle(billingCycle.name)
            return(<div className={'of-custom-hosting-slider__price'}>
              <span className={'text text-font-1-100'}>${billingCycle.price}</span>
              <span className={'cycle text-font-3-100'}>{cycle}</span>
            </div>)
          }
        }
      }
      return (<></>)
    }
    return (
      <div className={'of-custom-hosting-slider clearfix lines-border-1-100'}>
        <div className={'of-custom-hosting-slider__details'}>
            <div className={'of-custom-hosting-slider__option-value text-font-1-100'}>{getOptionValue()}</div>
            <div className={'of-custom-hosting-slider__name text-font-2-100'}>{getName()}</div>
        </div>
        <div className={'of-custom-hosting-slider__slider'}>
          <Slider
            className={'of-slider'}
            min={getMin()}
            max={getMax()}
            value={value}
            tooltip={true}
            onChange={(val)=>{
              setValue(val)
            }}
            onChangeComplete={()=>{
              const option = getSelectedOption(value)
              if(option && option.id){
                callback(config.id,option.id,sliderIndex,setConfigOptions)
              }
            }}
            format={(val)=>{
              const selected = getSelectedOption(val)
              if(selected){
                return (<>{selected.name}</>)
              }
              return (<></>)
            }}
            ref={sliderRef}
          />
        </div>
        {renderPrice()}
      </div>
    )
  }

  return (<></>)
}
CustomHostingSlider.propTypes = {
  config : PropTypes.object,
  productConfig : PropTypes.object,
  callback: PropTypes.func,
  sliderIndex: PropTypes.number,
  initValue: PropTypes.object,
  setConfigOptions:PropTypes.func
}

let CustomHostingConfig = props =>{
  const { location } = props
  const [configOptions,setConfigOptions] = useState([])
  const params = getDataFromURL(location.search)
  const cid = getCID(params)
  const {configurations} = useSelector(state=>({
    configurations: state.app.configurations
  }))
  const dispatch = useDispatch()
  const sliderCallback = useCallback((config_id,option_id,sliderIndex,setConfig)=>{
    const configoptionitem = {
      config_id,
      option_id
    }
    let newConfigOptions = configOptions
    newConfigOptions[sliderIndex] = configoptionitem
    if(setConfig){
      setConfig([...newConfigOptions])
    }
  },[configOptions])


  const renderConfig = () => {
    const  productConfig = configurations[cid]
    if(productConfig && productConfig.selectedProduct && productConfig.selectedProduct.attributes){
      const {config_options} = productConfig.selectedProduct.attributes
      if(config_options && config_options.length > 0){
        return config_options.map((config,index)=>{
          return (
            <CustomHostingSlider key={index} config={config} productConfig={productConfig} callback={sliderCallback} sliderIndex={index} setConfigOptions={setConfigOptions}/>
          )
        })
      }
    }
    return (<></>)
  }
  const continueCallback = (e) =>{
    e.preventDefault()
    const next = getCurrentStep(configurations,cid) + 1
    updateConfig(configurations,cid,{
      config:configOptions,
      step: next
    },dispatch)
  }

  const prevConfigOptions = useRef(null)
  useEffect(()=>{
    if(configOptions && JSON.stringify(configOptions)){
      if(prevConfigOptions.current!== JSON.stringify(configOptions)){
        updateConfig(configurations,cid,{config:configOptions},dispatch)
        prevConfigOptions.current = JSON.stringify(configOptions)
      }
    }
  },[configurations,cid,dispatch,configOptions])

  const renderHiddenSelectedConfig = () => {
    if(configOptions && JSON.stringify(configOptions)){
      return (<input type={'hidden'} value={JSON.stringify(configOptions)}/>)
    }
    return (<></>)
  }
  return (
    <div className={'of-step__wrapper of-custom-hosting-config'}>
      <Heading className={'of-custom-hosting-config__heading'}>How many resources do you need?</Heading>
      <div className={'of-custom-hosting-config__slider-wrapper'}>
        {renderConfig()}
        {renderHiddenSelectedConfig()}
      </div>
      <SolidButton className={'of-custom-hosting-config__button'} onClick={continueCallback}>Continue</SolidButton>
    </div>
  )
}

CustomHostingConfig = withRouter(CustomHostingConfig)

CustomHostingConfig.propTypes = {
  location: PropTypes.object
}

export default CustomHostingConfig